import { calendarKeys } from 'hooks/queries/calendar/calendarKeys'
import { AlmanacFileCalendarItem } from 'hooks/queries/calendar/types'
import { AlmanacFileShowItem } from 'hooks/queries/files/types'
import { useQueryClient } from 'react-query'
import { filesKeys } from 'hooks/queries/files/filesKeys'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'

export const useMarkFileAsViewed = () => {
  const queryClient = useQueryClient()
  const workspaceId = useCurrentWorkspaceId()

  const markFileAsViewed = (almanacFileKey?: string | null) => {
    if (!almanacFileKey) return

    const calendarQueries = queryClient.getQueriesData<AlmanacFileCalendarItem[]>(calendarKeys.all)
    const fileQueries = queryClient.getQueriesData<AlmanacFileShowItem[]>(filesKeys.all(workspaceId))

    calendarQueries.forEach(([queryKey, oldData]) => {
      if (!oldData || !Array.isArray(oldData)) return

      const newData = oldData.map((item) => {
        if (item.key === almanacFileKey) {
          return {
            ...item,
            viewed_at: new Date().toISOString(),
          }
        }
        return item
      })

      queryClient.setQueryData(queryKey, newData)
    })

    fileQueries.forEach(([queryKey]) => {
      queryClient.setQueryData(queryKey, (oldData: any) => {
        if (!oldData || !Array.isArray(oldData)) return oldData

        const newData = oldData?.map((file: AlmanacFileShowItem) => {
          if (file.key === almanacFileKey) return { ...file, viewed_at: new Date().toISOString() }

          return file
        })

        return newData
      })
    })
  }

  return { markFileAsViewed }
}
